var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExclamationCircle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_12409",
    "data-name": "Group 12409",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.141,
    height: 16.141,
    viewBox: "0 0 16.141 16.141",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_9501",
    "data-name": "Path 9501",
    d: "M0,0H16.141V16.141H0Z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_9502",
    "data-name": "Path 9502",
    d: "M3,9.053A6.053,6.053,0,1,0,9.053,3,6.053,6.053,0,0,0,3,9.053",
    transform: "translate(-0.982 -0.982)",
    fill: "none",
    stroke: "#c61010",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_9503",
    "data-name": "Path 9503",
    d: "M12,9v2.69",
    transform: "translate(-3.93 -2.947)",
    fill: "none",
    stroke: "#c61010",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_9504",
    "data-name": "Path 9504",
    d: "M12,16v.007",
    transform: "translate(-3.93 -5.24)",
    fill: "none",
    stroke: "#c61010",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExclamationCircle);
export default __webpack_public_path__ + "static/media/exclamation-circle.43f7f9906ca068b0581b59e077a82249.svg";
export { ForwardRef as ReactComponent };